import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";

export const RelatedBlogPosts = ({ slug }) => {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setPosts([]); setError(false);
    api.get(`/blog/${encodeURIComponent(slug)}/related`)
      .then(({ data }) => { if (active) setPosts(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [slug, retry]);
  if (!posts.length && !error) return null;
  return (
    <section className="mt-16 border-t border-slate-200 pt-8" data-testid="related-blog-posts" aria-labelledby="related-blog-title">
      <h2 id="related-blog-title" data-testid="related-blog-title" className="font-display text-lg font-bold mb-6">Keep reading</h2>
      {error && <p role="alert" data-testid="related-blog-error" className="text-sm text-slate-600">More posts couldn't load. <button type="button" data-testid="related-blog-retry" className="text-emerald-800 underline" onClick={() => setRetry((n) => n + 1)}>Try again</button></p>}
      <div className="grid md:grid-cols-3 gap-6">
        {posts.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} data-testid={`related-blog-${post.slug}`} className="group min-w-0 flex flex-col border border-slate-200 rounded-lg overflow-hidden hover:border-[#D4AF37] hover:-translate-y-1 transition-[border-color,transform] duration-200">
            {post.image && <div className="aspect-[16/10] bg-slate-50"><img src={post.image.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${post.image}` : post.image} alt="" loading="lazy" className="w-full h-full object-contain" data-testid={`related-blog-image-${post.slug}`} /></div>}
            <div className="p-5 flex-1 flex flex-col">
              {post.tags?.[0] && <p className="text-xs font-semibold text-emerald-700 mb-2" data-testid={`related-blog-tag-${post.slug}`}>{post.tags[0]}</p>}
              <h3 className="font-display font-bold text-base leading-snug break-words" data-testid={`related-blog-title-${post.slug}`}>{post.title}</h3>
              <p className="text-sm text-slate-500 mt-2 line-clamp-3 break-words" data-testid={`related-blog-excerpt-${post.slug}`}>{post.excerpt}</p>
              <span className="text-sm text-emerald-800 font-semibold mt-4 flex items-center gap-1">Read post <ArrowUpRight size={15} /></span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};